import React from 'react';
import { isEmpty } from 'lodash';
import { Button } from 'tuui';
import { CloseIcon } from 'taboola-ultimate-ui';
import { FormattedMessage } from '../../../../modules/taboola-common-frontend-modules/i18n';
import styles from './selectedFilters.module.scss';

export const SelectedFilters = ({ filters, onClick, onRemove }) => {
    if (isEmpty(filters)) {
        return null;
    }

    const comps = filters.map((filter, index) => {
        return filter.selectedSubFilters.map(selectedSubFilter => {
            const key = `${filter.selectedFilter}-${index}-${selectedSubFilter.filterName}`;
            return (
                <div
                    key={key}
                    onClick={() => onClick(filter.selectedFilter, selectedSubFilter)}
                    className={styles['selected-filter-button']}
                    role="button"
                    aria-label="selected-filter-button"
                >
                    <FormattedMessage
                        id={`campaign.editor.targeting.audience.details.${selectedSubFilter.filterValue}`}
                        defaultMessage="{detail}"
                        values={{ detail: selectedSubFilter.filterName }}
                    />
                    <Button
                        className={styles['remove-filter-button']}
                        onClick={e => {
                            e.stopPropagation();
                            onRemove(filter.selectedFilter, selectedSubFilter);
                        }}
                        aria-label="remove-filter-button"
                    >
                        <div className={styles['remove-filter-button-container']}>
                            <CloseIcon height="100%" width="100%" />
                        </div>
                    </Button>
                </div>
            );
        });
    });

    return <div className={styles['container']}>{comps}</div>;
};
